module.exports = __webpack_public_path__ + "img/cloud04.15c6c8e1.png";